export function openUrl(url: string) {
	const a = document.createElement('a');
	a.href = url;
	a.rel = 'noopener';
	a.target = '_blank';
	document.body.append(a);
	a.click();
	a.remove();
}
